































































































































































































































import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { Row, EditableStatus, Column, Table } from '@/main/utils/table';

import {
	END_LOADING,
	START_LOADING,
	TABLE_DATA,
} from '@/main/store/listEditTypes';

import { saveButton, deleteButton } from '@/main/utils/tableOperations';

import _, { toNumber } from 'lodash';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import {
	PRACOVNI_POZICE, PRACOVNI_POZICE_COLS,
	MIN_DISCOUNT_LIMIT,
	MAX_DISCOUNT_LIMIT,
	LABOR_ITEM,
	LABOR_ITEM_TOTAL,
	LABOUR_ROW_EDITED,
	LABOUR_ROW_SAVED,
	LABOUR_SELECTED,
	LABOUR_COST_CENTER_CHANGED,
} from '../constants';
import { store } from '../store/edit';


import { apiProvider as OZakazkaProvider } from '../api';
import { LABOUR } from '../../zakazka/constants';


export default EditStoreMixin.extend({
	name: 'OZakazkaPPTable',
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			loadingDropdown: false,
			dataInput: '',
			loInput: '',
			cancelDataInput: '',
			cancelLoInput: '',
			CasJdnPocInput: '',
			cancelCasJdnPocInput: '',
			loPrice: '',
			cancelLoPrice: '',
			PRACOVNI_POZICE,
			showDiscountDialog: false,
			pracovniPoziceCols: PRACOVNI_POZICE_COLS,
			localLabourNumber: '',
			dependencies: {
				PRACOVNI_POZICE,
			},
		};
	},
	computed: {
		watchlistCheck() : boolean | null {
			return this.WatchlistFlag;
		},
		LaborOpTable(): any {
			let idColumn: number;
			_.forEach(this.dependentTables.PracovniPozice.columns, (col: Column) => {
				if (col?.columnId !== null) { idColumn = toNumber(col?.columnId); } else {
					col.columnId = (idColumn + 1).toString();
					idColumn = toNumber(col.columnId);
				}
			});

			return this.dependentTables.PracovniPozice;
		},
		...genVuexComputeds(store),
	},
	methods: {
		async toggleDiscountDialog() {
			this.showDiscountDialog = !this.showDiscountDialog;
		},
		async saveDiscount() {
			if (
				this.TotDiscPercentLabor! > MAX_DISCOUNT_LIMIT
        || this.TotDiscPercentLabor! < MIN_DISCOUNT_LIMIT
			) {
				this.TotDiscPercentLabor = 0;
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgNotMoreDiscThn100Per'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			const row = { cells: [], operations: 0 } as Row;
			const isDiscountApplicable = await this.checkUserDiscountLimit(
				false,
				this.TotDiscPercentLabor,
				row
			);
			if (isDiscountApplicable) {
				this.updateDiscount();
			}
		},
		async updateDiscount() {
			this.showDiscountDialog = false;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await OZakazkaProvider.updateDiscountToAllLabor(
				this.TotDiscPercentLabor,
				this.OzakazkaId!,
			);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			this.fetchTableData([PRACOVNI_POZICE]);
		},
		createRow() {
			(this.$refs.editableTable as any).createRow();
			this.dataInput = '';
			this.loInput = '';
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.PracovniPozice.rows = rows;
		},
		updateRow(rowUpdateData: {
			tableName: string;
			updateStatus: EditableStatus;
			rowId: number;
			row: Row;
		}) {
			if (rowUpdateData.updateStatus === EditableStatus.DELETED) {
				return;
			}
			this.$store.commit(`${this.storeUri}/updateTableRow`, rowUpdateData);
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			const StartTime = performance.now();
			const loDescIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_DESCRIPTION;
			const CasJdnPocIndex: any = this.dependentTables.PracovniPozice.cellNames?.CAS_JDN_POC;
			const loNoIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_NUMBER;
			const laborPriceIndex: number = this.dependentTables.PracovniPozice.cellNames!.PC_BEZ_DPH_NAD;
			this.loPrice = row.cells[laborPriceIndex];
			this.cancelLoPrice = row.cells[laborPriceIndex];
			this.localState.LabourValue = '';
			this.dataInput = row.cells[loDescIndex];
			this.loInput = row.cells[loNoIndex];
			this.cancelDataInput = row.cells[loDescIndex];
			this.cancelLoInput = row.cells[loNoIndex];
			this.CasJdnPocInput = row.cells[CasJdnPocIndex];
			this.cancelCasJdnPocInput= row.cells[CasJdnPocIndex];		
			let iTotalTimeTaken = performance.now() - StartTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, LABOUR_ROW_EDITED, seconds);
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			const StartTime = performance.now();
			const TuColumnIndex: number = this.dependentTables.PracovniPozice.cellNames!.CAS_JDN_POC!;
			const TuColumnValue = newRow.cells[TuColumnIndex];
			await this.onTimeUnitLeave(TuColumnValue, newRow, TuColumnIndex);
			const loDescIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_DESCRIPTION;
			newRow.cells[loDescIndex] = this.dataInput;
			const loNoIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_NUMBER;
			newRow.cells[loNoIndex] = this.loInput;
			const CasJdnPocIndex: any = this.dependentTables.PracovniPozice.cellNames?.CAS_JDN_POC;
			newRow.cells[CasJdnPocIndex] = this.CasJdnPocInput;
			const discPerIndex: number = this.dependentTables.PracovniPozice.cellNames!.DISCOUNT_PERCENT;
			const laborPriceIndex: number = this.dependentTables.PracovniPozice.cellNames!.PC_BEZ_DPH_NAD;
			newRow.cells[laborPriceIndex] = this.loPrice;
			const errormsg = null;
			if (
				newRow.cells[discPerIndex]! < MIN_DISCOUNT_LIMIT
        || newRow.cells[discPerIndex]! > MAX_DISCOUNT_LIMIT
			) {
				newRow.cells[discPerIndex] = 0;
				return this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('MSGmsgDiscountShouldBe0To100'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
			if (
				this.checkUserDiscountLimit(true, newRow.cells[discPerIndex], newRow) != true
			) {
				newRow.cells[discPerIndex] = 0;
			}
			let iTotalTimeTaken = performance.now() - StartTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, LABOUR_ROW_SAVED, seconds);
		},
		checkUserDiscountLimit(Level: boolean, sleva: any, newRow: Row) {
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) { errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc'); } else {
				if (Level) {
					this.TotDiscPercentLabor = parseFloat("0");
					let count = 0;
					_.map(this.dependentTables.PracovniPozice.rows, () => {
						const discountColId = this.dependentTables.PracovniPozice.cellNames?.DISCOUNT_PERCENT;
						const recordId = this.dependentTables.PracovniPozice.cellNames?.LO_NUMBER;
						const lineItemDiscountValue: number = parseInt(_.defaultTo(this.dependentTables.PracovniPozice.rows[count].cells[discountColId as number], 0));
						if (this.dependentTables.PracovniPozice.rows[count].cells[recordId as number] !== newRow.cells[recordId as number]) {
							this.TotDiscPercentLabor = parseFloat((_.defaultTo(this.TotDiscPercentLabor, 0) as any) + lineItemDiscountValue);
						}
						count += 1;
					});
					const currentValue = parseFloat(sleva);
					if (currentValue > 0) {
						this.TotDiscPercentLabor = parseFloat((_.defaultTo(this.TotDiscPercentLabor, 0) as any) + currentValue);
					}
				}
				if (Level) {
					errormsg = this.validateUserDiscount(
						this.loggedUser.DiscountLimitConfigData.LaborItemPer,
						Level,
						sleva,
					);
				}
				if (errormsg !== null) {
					this.TotDiscPercentLabor = 0;
					this.showErrorAlert({
						message: `${errormsg}${this.LocalizeAndReplace(
							this.LocalizePopisostatni(Level ? LABOR_ITEM : LABOR_ITEM_TOTAL),
							{ key: this.LocalizePopisostatni('Level_Limit'), value: '' },
						).toLowerCase()}.`,
						options: { type: 'error' },
						localizeMessage: false,
					});
					return false;
				}
				errormsg = this.validateUserDiscount(
					this.loggedUser.DiscountLimitConfigData.LaborItemTotalPer,
					false,
					sleva,
				);
			}
			if (errormsg !== null) {
				this.TotDiscPercentLabor = 0;
				this.showErrorAlert({
					message: `${errormsg}${this.LocalizeAndReplace(
						this.LocalizePopisostatni(Level ? LABOR_ITEM : LABOR_ITEM_TOTAL),
						{ key: this.LocalizePopisostatni('Level_Limit'), value: '' },
					).toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		async fetchTableData(
			this: any,
			tablesToFetch: string[] = Object.values(this.zakazkaTables),
		): Promise<any> {
			const tables: [string, any][] = tablesToFetch.map((item) => [item, item]);
			return Promise.all(
				tables.map(([key, value]) => this.$store.dispatch(
					`${this.storeUri}/${value}_${TABLE_DATA}`,
					{ filter: this[`${value}Filter`] },
				)),
			);
		},
		validateUserDiscount(discountper: number, Level: boolean, sleva: any) {
			let errormsg = null;
			if (discountper === 0) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
				return errormsg;
			} if (!Level && this.TotDiscPercentLabor === null) {
				errormsg = this.LocalizeChyboveHlasky('msgReqDiscOrValue');
				return errormsg;
			} if (
				discountper > 0
        && discountper < (sleva === null ? 0 : sleva)
			) {
				errormsg = this.LocalizeChyboveHlasky(
					'msgNotAplyMoreThnDiscPer',
				).replace('<DISC_PER>', `${discountper}%`);
				return errormsg;
			} if (
				Level
        && discountper > 0
        && discountper < (sleva === null ? 0 : sleva)
			) {
				errormsg = this.LocalizeChyboveHlasky(
					'msgNotAplyMoreThnDiscPer',
				).replace('<DISC_PER>', `${discountper}%`);
				return errormsg;
			} if (
				!Level
        && discountper > 0
        && discountper
          < (this.TotDiscPercentLabor === null ? 0 : this.TotDiscPercentLabor)
			) {
				errormsg = this.LocalizeChyboveHlasky(
					'msgNotAplyMoreThnDiscPer',
				).replace('<DISC_PER>', `${discountper}%`);
				return errormsg;
			}
			return errormsg;
		},
		rowCancel(row: any) {
			if (row !== undefined) {
				const loDescIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_DESCRIPTION;
				const loNoIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_NUMBER;
				const CasJdnPocIndex: any = this.dependentTables.PracovniPozice.cellNames?.CAS_JDN_POC;
				const laborPriceIndex: number = this.dependentTables.PracovniPozice.cellNames!.PC_BEZ_DPH_NAD;
				if (
					this.cancelDataInput !== row.row.cells[loDescIndex]
          || this.cancelLoInput !== row.row.cells[loNoIndex]
				) {
					this.dataInput = this.cancelDataInput;
					row.row.cells[loDescIndex] = this.cancelDataInput;

					this.loInput = this.cancelLoInput;
					row.row.cells[loNoIndex] = this.cancelLoInput;

					this.CasJdnPocInput = this.cancelCasJdnPocInput;
					row.row.cells[CasJdnPocIndex] = this.cancelCasJdnPocInput;
				}
				if (this.cancelLoPrice !== row.row.cells[laborPriceIndex]) {
					this.loPrice = this.cancelLoPrice;
					row.row.cells[laborPriceIndex] = this.cancelLoPrice;
				}
			}
		},
		onInput(event: any, row: Row, columnId: number) {
			this.dataInput = event;
			row.cells[columnId] = event;
		},
		async onTimeUnitChange(value: any, columnId: number,updateCol: any, row: Row) {			
			updateCol(value, columnId);
			row.cells[columnId] = value;			
		},
		async onTimeUnitLeave(tuValue: any, row: Row, columnId: number) {	
			if (tuValue <= 0 || tuValue === '' || tuValue === undefined) {					
					this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectTu'),
					options: { type: 'error' },
					localizeMessage: false,
				});
					row.cells[columnId] = this.CasJdnPocInput;					
					return false;
			}			
			if (tuValue.toString().indexOf(".") != -1) {					
					this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectTu'),
					options: { type: 'error' },
					localizeMessage: false,
				});	
					row.cells[columnId] = this.CasJdnPocInput;				
					return false;
			}

			this.CasJdnPocInput = tuValue;
			row.cells[columnId] = tuValue;

			const laborNumberIndex: number = this.dependentTables.PracovniPozice.cellNames!.LO_NUMBER;
			let loNumber: string = row.cells[laborNumberIndex].toString();

			const laborPriceIndex: number = this.dependentTables.PracovniPozice.cellNames!.PC_BEZ_DPH_NAD;			
			const costCenterIndex: number = this.dependentTables.PracovniPozice.cellNames!.STREDNAKL_OZN;
			let costCenterId: number = row.cells[costCenterIndex];
			let laborPrice: number = 0;
			if (row.cells[laborNumberIndex].toString().length < 8) {
				loNumber = `0${row.cells[laborNumberIndex].toString()}`;
			}
			if (loNumber !== '') {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				if(costCenterId !== null)
				{
					 const{data: lbrPrice} = await OZakazkaProvider.getPlannedLevelLaborPriceWithCC(this.edit.OzakazkaId!, loNumber, tuValue, costCenterId);					 
					 laborPrice = lbrPrice;
				} 
				else
				{
					 const{data: lbrPrice} = await OZakazkaProvider.getPlannedLevelLaborPrice(this.edit.OzakazkaId!, loNumber, tuValue);		
					 laborPrice = lbrPrice;
				}
				this.loPrice = laborPrice.toString();
				row.cells[laborPriceIndex] = laborPrice;
				//updateCol(laborPrice, laborPriceIndex);
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}			
		},
		async onTuLeaveColumn(tuValue: any, row: Row, columnId: number, updateCol:any) {    
            if (tuValue <= 0 || tuValue === '') {                   
                    this.showErrorAlert({
                    message: this.LocalizeChyboveHlasky('msgCorrectTu'),
                    options: { type: 'error' },
                    localizeMessage: false,
                });
                updateCol(this.CasJdnPocInput, columnId);
                    row.cells[columnId] = this.CasJdnPocInput;              
                    return false;
                
            }           
             updateCol(tuValue, columnId);  
            this.CasJdnPocInput = tuValue;              
            row.cells[columnId] = tuValue;            
        },
		getLaborDescription(row: Row, columnId: number, isEditing: boolean) {
			return row.cells[columnId];
		},
		getPracovnikDescription(row: Row, columnId: number, isEditing: boolean) {
			const result: any = this.dropdownList.TechiciansList.find(
				(item: any) => item.Value === parseInt(row.cells[columnId]),
			);
			return result?.Text;
		},
		getCostCenterDescription(row: Row, columnId: number, isEditing: boolean) {
			const result: any = this.dropdownList.StrednaklOzn.find(
				(item: any) => item.Value === parseInt(row.cells[columnId]) && item.ProvozovnaId === this.edit.ProvozovnaId!,
			);
			return result?.Text;
		},
		getServiceJobDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.ServiceJobForItems.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		async remoteMethod() {},
		async changeMethod(val: string, row: Row, columnId: number) {
			const startTime = performance.now();
			const loDescIndex: any = this.dependentTables.PracovniPozice.cellNames?.LO_DESCRIPTION;			
			const CasJdnPocIndex: any = this.dependentTables.PracovniPozice.cellNames?.CAS_JDN_POC;
			const laborPriceIndex: number = this.dependentTables.PracovniPozice.cellNames!.PC_BEZ_DPH_NAD;			
			row.cells[loDescIndex] = '';
			row.cells[CasJdnPocIndex] = '';
			row.cells[laborPriceIndex] = '';	
			if ( val === '' || val === undefined) {
				return false;
			}	
			
			this.localState.LabourValue = val;
			const result: any = this.dropdownList.LabourList.find(
				(item: any) => item.Value === val,
			);
			this.dataInput = result?.Text;
			this.loInput = result?.Label;
			row.cells[loDescIndex] = result?.Text;			
			this.CasJdnPocInput = result?.TimeUnit;
			row.cells[CasJdnPocIndex] = result?.TimeUnit;			
			if (result?.TimeUnit === undefined) {
				return false;
			}
			this.localLabourNumber = val;			
			const { data: laborPrice } = await OZakazkaProvider.getPlannedLevelLaborPrice(this.edit.OzakazkaId!, val, result?.TimeUnit);						
			this.loPrice = laborPrice;
			row.cells[laborPriceIndex] = laborPrice;
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, LABOUR_SELECTED, seconds);
		},		
		async onCostCenterChanged(val: string, row: Row, columnId: number) {
			const startTime = performance.now();
			const laborNumberIndex: number = this.dependentTables.PracovniPozice.cellNames!.LO_NUMBER;
			let loNumber: string = row.cells[laborNumberIndex].toString();
			const CasJdnPocIndex: number = this.dependentTables.PracovniPozice.cellNames!.CAS_JDN_POC;
			let timeUnit: number = row.cells[CasJdnPocIndex].toString();
			if (row.cells[laborNumberIndex].toString().length < 8) {
				loNumber = `0${row.cells[laborNumberIndex].toString()}`;
			}
			if (loNumber !== '' && timeUnit !== undefined) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const { data: laborPrice } = await OZakazkaProvider.getPlannedLevelLaborPriceWithCC(this.edit.OzakazkaId!, loNumber, timeUnit, Number(val));
				const laborPriceIndex: number = this.dependentTables.PracovniPozice.cellNames!.PC_BEZ_DPH_NAD;
				this.loPrice = laborPrice;
				row.cells[laborPriceIndex] = laborPrice;
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, LABOUR_COST_CENTER_CHANGED, seconds);
		},
		async deleteRow(item: any) {
				const confirmDelete = await this.showConfirm({
				message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
				title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
				options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (confirmDelete) {
					this.$store.commit(`${this.storeUri}/${START_LOADING}`);
					await OZakazkaProvider.deletelabor(item.rowId)
					await this.fetchTableData([PRACOVNI_POZICE]);
					this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		
		/**
     * This table is being retrieved from BE class which inturn implements BaseCrudGridSelectGridFacade,
     * so it is not possible to override GridSchema method(BaseCrudGridFacade class).
     * This method is used to retrieve grid columns in which we can write column-hide logic .
     * So keeping column-hide logic as is in FE.
     */

	},
});
